import { ITemplateScope } from "AngularFormly";
import { get, orderBy } from "lodash";
import { MachineConfigurationSoftware } from "../../../../models/machineConfiguration";

interface SoftwareListScope extends ITemplateScope {
  getSoftwares: () => MachineConfigurationSoftware[];
}

export class SoftwareUpdateSoftwareListController {
  static $inject = ["$scope"];

  private readonly softwares: MachineConfigurationSoftware[];

  constructor(private readonly $scope: SoftwareListScope) {
    const softwares =
      get(this.$scope.model ?? {}, this.$scope.options.key) ?? [];
    this.softwares = orderBy(softwares, [
      "Property",
      "Location",
      "SerialNumber",
      "Date",
    ]);

    $scope.getSoftwares = () => this.getSoftwares();
  }

  getSoftwares() {
    return this.softwares;
  }
}
